import { Controller } from "@hotwired/stimulus";
import { application } from "src/stimulus/application";

// Site::Prefecture::HouseMakerIndex::Component の Stimulus コントローラ。
// landIeul: DisplayButton の「もっと見る」で invisibleList (display:none) を一括表示し、
// ボタンと clearArea グラデーションを取り除く (React: visibilityCheck.visibleData())。
class SitePrefectureHouseMakerIndexController extends Controller {
  static targets = ["invisibleList", "button", "clearArea"];

  declare readonly invisibleListTarget: HTMLElement;
  declare readonly hasButtonTarget: boolean;
  declare readonly buttonTarget: HTMLButtonElement;
  declare readonly clearAreaTargets: HTMLElement[];

  showMore(): void {
    this.invisibleListTarget.style.display = "block";
    if (this.hasButtonTarget) {
      this.buttonTarget.remove();
    }
    this.clearAreaTargets.forEach((el) => el.remove());
  }
}

application.register(
  "site--prefecture--house-maker-index",
  SitePrefectureHouseMakerIndexController,
);
